import { CollectionCard, CollectionContainer, CollectionImagesContainer, CollectionImagesSubContainer, CollectionSubTitle, CollectionTitle, Image1, Image2 } from "./styles";

type CollectionProps = {
  collections: {
    id: string,
    userId: string,
    following: [
      {
        id: string,
        userId: string,
        collections: { name: string, publications: string[] }
      }
    ]
  }[]
};

export default function Collection({ collections }: CollectionProps) {
  return (
    <CollectionContainer>
      {collections && collections.map((collection, index) => {
        return (
          <CollectionCard key={index}>
            <CollectionImagesContainer>
              <Image1 src={collection.following[0].collections.publications[0]} alt="image1" />
              <CollectionImagesSubContainer>
                <Image2 src={collection.following[0].collections.publications[1]} />
                <Image2 style={{ borderTopRightRadius: '12px' }} src={collection.following[0].collections.publications[2]} />
                <Image2 src={collection.following[0].collections.publications[3]} />
                <Image2 style={{ borderBottomRightRadius: '12px' }} src={collection.following[0].collections.publications[4]} />
              </CollectionImagesSubContainer>
            </CollectionImagesContainer>
            <CollectionTitle>
              Gojo e Suguro
            </CollectionTitle>
            <CollectionSubTitle>
              1 arquivo
            </CollectionSubTitle>
          </CollectionCard>
        )
      })}
    </CollectionContainer>
  )
}